import cx from 'classnames';
import numeral from 'numeral';
import pluralize from 'pluralize';
import { observer } from 'mobx-react';
import { useMemo } from 'react';

const LeaderboardCampaignInfo = observer(({ campaign, column, index }) => {
  const rank = useMemo(() => index + 1);

  const rankedInTopN = (n) => {
    const rankings = Array.from(Array(n + 1).keys());
    const rankingsWithoutZero = rankings.filter((val) => val !== 0);
    return rankingsWithoutZero.includes(rank);
  };

  return (
    <li
      className={cx('infinite-item flex items-center relative', {
        'border border-solid border-grey-30 p-1 rounded-sm cursor-pointer mb-1':
          rankedInTopN(3),
      })}
      onClick={() => {
        if (rankedInTopN(3)) {
          window.location = campaign.url;
        }
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: campaign.userAvatar }} />

      <div className='campaign-info flex flex-col w-3/4'>
        <div className='flex text-xs'>
          <a
            className='text-cw-black font-bold underline'
            href={`${campaign.url}`}
          >
            {campaign.name}
          </a>
        </div>

        <div className='flex items-center'>
          {campaign.showCurrencyConverter && column == 'amount' && (
            <span
              aria-label={`Converted from ${campaign.currencyUnit}${campaign.currencyName}`}
              className='tooltipped tooltipped-ne tooltipped-no-delay tooltipped-multiline'
            >
              <span className='cw-icon-loop currency-converter' />
            </span>
          )}
          <p className='amount-raised text-cw-green font-bold m-0'>
            {column == 'amount'
              ? `${campaign.formattedRaiseAmount} raised`
              : `${campaign.paidDonationCount} ${pluralize(
                  'donations',
                  campaign.paidDonationCount
                )}`}
          </p>
        </div>
      </div>
      {rankedInTopN(3) && (
        <>
          <div className='ml-auto text-xs text-grey-50 flex items-center'>
            {numeral(rank).format('0o')}
            <span className='cw-icon-angle-right icon inline-block ml-1 font-bold' />
          </div>
          <div className='campaign-progress-bar bg-grey-30 mt-2 absolute bottom-0 left-0 rounded-b-sm w-full'>
            <div
              className='fill bg-cw-navy absolute bottom-0 left-0 rounded-bl-sm'
              style={{ width: `${campaign.progressBarPercentage}%` }}
            />
          </div>
        </>
      )}
    </li>
  );
});

export default LeaderboardCampaignInfo;
